import { withResult } from 'feathers-fletching';
import { disallow } from 'feathers-hooks-common';
import { validateSchema } from 'straightline-utils/hooks';

const withResults = withResult({
  shipment: async (result, context) => {
    if (!context.params.$include?.includes('shipment')) {
      return undefined;
    }

    const shipment = await context.params.loader
      .service('api/shipment-matches')
      .load(result.shipment_id);

    return shipment;
  }
});

export default {
  before: {
    all: [],
    find: [],
    get: [],
    create: [validateSchema],
    update: [disallow()],
    patch: [disallow()],
    remove: [disallow()]
  },
  after: {
    all: [withResults],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
};
